import React, { useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import DataGrid from "../../components/DataGrid";
import Toggle from "../../components/DataGrid/toggle.js";

export default function ContaList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const gridRef = useRef();

  const filtroInicial = searchParams.get("filtro") || "";
  const [ativoFiltro, setAtivoFiltro] = useState(searchParams.get("ativo") ?? "true");

  const handleAtivoChange = (valor) => {
    setAtivoFiltro(valor);
    const params = new URLSearchParams(searchParams);
    if (valor !== "") {
      params.set("ativo", valor);
    } else {
      params.delete("ativo");
    }
    setSearchParams(params);
  };

  const handleToggleStatus = async (id, ativo) => {
    try {
      await axios.put(`${process.env.REACT_APP_API}/conta/${id}/status`, {
        id,
        ativo: !ativo
      });
      gridRef.current?.refresh();
    } catch (error) {
      console.error("Erro ao alterar status:", error);
    }
  };

  const columns = [
    {
      field: "nome",
      header: "Nome",
      sortable: true,
      render: (row) => (
        <div className="flex flex-col">
          <span className="font-medium text-gray-800">{row.nome}</span>
          {row.nomeFantasia && (
            <span className="text-xs text-gray-500">{row.nomeFantasia}</span>
          )}
        </div>
      ),
    },
    {
      field: "documento",
      header: "Documento",
      sortable: true,
      render: (row) => row.documento || "-",
    },
    {
      key: "ativo",
      header: "Ativo",
      className: "text-center",
      headerClassName: "text-center",
      width: "100px",
      render: (row) => (
        <div onClick={(e) => e.stopPropagation()}>
          <Toggle
            value={row.ativo}
            onChange={() => handleToggleStatus(row.id, row.ativo)}
          />
        </div>
      ),
    },
    {
      key: "acoes",
      header: "Ações",
      width: "100px",
      className: "text-center",
      headerClassName: "text-center",
      render: (row) => (
        <button
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/contas/${row.id}`);
          }}
          className="p-2 text-gray-600 hover:text-slate-900 hover:bg-gray-100 rounded"
          title="Editar"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
          </svg>
        </button>
      ),
    },
  ];

  const externalFilters = ativoFiltro !== "" ? { ativo: ativoFiltro } : {};

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Contas</h1>
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600">Status:</span>
          <select
            value={ativoFiltro}
            onChange={(e) => handleAtivoChange(e.target.value)}
            className="px-3 py-1.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-slate-500"
          >
            <option value="true">Ativos</option>
            <option value="false">Inativos</option>
            <option value="">Todos</option>
          </select>
        </div>
      </div>

      <DataGrid
        ref={gridRef}
        endpoint={`${process.env.REACT_APP_API}/conta`}
        columns={columns}
        filters={externalFilters}
        initialFilter={filtroInicial}
        emptyMessage="Nenhuma conta cadastrada"
        emptyAction={
          <button
            onClick={() => navigate("/contas/nova")}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Cadastrar primeira conta
          </button>
        }
        headerAction={
          <button
            onClick={() => navigate("/contas/nova")}
            className="px-4 py-2 text-sm rounded bg-slate-900 text-white hover:bg-slate-800"
          >
            Nova Conta
          </button>
        }
        onRowClick={(row) => navigate(`/contas/${row.id}`)}
      />
    </div>
  );
}